import CellHOC from '@platform/react/hoc/list/cell'
import LabeledHOC from '@platform/react/hoc/list/labeled'
import { ListItemCellOrganisationNumber } from 'ui/Element/List/Item/Cell/Organisation/Number'

export default CellHOC(
  LabeledHOC(
    props => props.label,
    ListItemCellOrganisationNumber,
  ),
)
